import { CSSProperties } from 'react';
import Lottie from 'lottie-react';
import animationData from './hostIsHereAnimation.lottie.json';

type Props = {
  style?: CSSProperties;
};

export default function HostIsHereAnimation({ style }: Props) {
  return (
    <Lottie
      animationData={animationData}
      data-test="host-is-here-animation"
      loop={true}
      style={{
        width: '100%',
        height: '100%',
        ...style,
      }}
    />
  );
}
